import { useState } from 'react';
import { Columns, FoldPanel, Specimens, Switch } from '@src/components';

export function SwitchSection() {
  const [reminders, setReminders] = useState(true);
  const [publicList, setPublicList] = useState(false);
  const [archived, setArchived] = useState(true);

  return (
    <FoldPanel
      id="switches"
      title="Switches"
      hint="A setting, not a choice. The thumb slides; the selection colour means on. Same tokens as a ticked box."
      example={`<Switch
  label="Email reminders"
  checked={reminders}
  onCheckedChange={setReminders}
/>`}
    >
      <Specimens label="States" note="Flip them, tab to them — hover deepens the track.">
        <Columns columns="fill" gap={5}>
          <Switch
            label="Email reminders"
            checked={reminders}
            onCheckedChange={setReminders}
            hint="One email, the day before the draw."
          />
          <Switch
            label="Show me on the public list"
            checked={publicList}
            onCheckedChange={setPublicList}
          />
          <Switch
            label="Locked while the game is archived"
            checked={archived}
            onCheckedChange={setArchived}
            disabled
            hint="Archived games are read-only."
          />
          <Switch
            label="Off and locked"
            checked={false}
            onCheckedChange={() => undefined}
            disabled
          />
        </Columns>
      </Specimens>
    </FoldPanel>
  );
}
